<template>
  <div class="screen-2">
    <div class="container" id="about">
      <div class="row">
        <div class="col-12 d-lg-none">
          <TitleWidget class="text-center">{{ $t(locale.s2.header) }}</TitleWidget>
        </div>
        <div class="col-12 col-lg-6 order-0 order-lg-1 pt-lg-5">
          <div class="d-lg-block d-none pt-lg-5 green-subline">
            <TitleWidget>{{ $t(locale.s2.header) }}</TitleWidget>
          </div>
          <div class="content content-large pt-4 pt-lg-0" v-html="$t(locale.s2.text)"></div>
        </div>
        <div class="col-12 col-lg-6 order-1 order-lg-0">
          <div class="screen2-slider mt-3 mt-lg-0 ml-sm-auto mr-sm-auto mt-sm-4 mb-sm-4">
            <carousel
                :items="1"
                :nav="false"
                :responsive="{
                  0: {
                    nav: false,
                  },
                  576: {
                    nav: true,
                    navText: [
                        '<img class=fa-rotate-180 src=/img/arrow-black.svg>',
                        '<img src=/img/arrow-black.svg>'
                    ],
                  }
                }"
            >
              <img v-for="slideSrc in sliderImages" :key="slideSrc.id" :src="slideSrc.src" class="img-fluid">
            </carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel"
import TitleWidget from "@/components/common/TitleWidget";
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'ScreenAbout',
  components: {TitleWidget, carousel},
  data: () => {
    return {
      locale: stringsKeys,
      sliderImages: [
        {id: 0, src: "/img/about-slider-image-0.jpg"},
        {id: 1, src: "/img/about-slider-image-1.jpg"},
        {id: 2, src: "/img/about-slider-image-2.jpg"},
        {id: 3, src: "/img/about-slider-image-3.jpg"},
        {id: 4, src: "/img/about-slider-image-4.jpg"},
        {id: 5, src: "/img/about-slider-image-5.jpg"},
        {id: 6, src: "/img/about-slider-image-6.jpg"},
        {id: 7, src: "/img/about-slider-image-7.jpg"},
        {id: 8, src: "/img/about-slider-image-8.jpg"},
      ],
    }
  }
}
</script>

<style lang="scss">
@import "src/scss/colors";

.screen-2 {
  background-color: $white;
  padding-top: 60px;
  padding-bottom: 50px;

  @media (min-width: 576px) {
    padding-top: 140px;
    padding-bottom: 80px;
  }

  .screen2-slider {
    @media (min-width: 576px) {
      max-width: 435px;
    }
  }

  .owl-theme {
    .owl-nav {
      &.disabled {
        + .owl-dots {
          margin-top: 10px;
        }
      }

      display: flex !important;
      justify-content: space-between;

      [class*='owl-'] {
        width: auto;
        height: auto;
        padding: 0;
        background-color: transparent !important;
        z-index: 1;
      }

      @media (min-width: 576px) {
        margin-top: 2rem;
      }
    }

    .owl-dots {
      transform: translateY(-100%);
    }
  }
}

.green-subline {
  &:after {
    content: '';
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
    width: 72px;
    height: 3px;
    background-color: #00D665;
  }
}
</style>